import { useMemo } from "react";

import { ProductKey } from "@/components/signup/utils/products.ts";
import { useLocation } from "@/utils/location-provider";

const JSM_REFERRER_PATTERN =
    /^\/(?:[a-z]{2}(?:-[a-z]{2,4})?\/)?software\/jira\/service-management(\/|$)/i;
const JSM_BUNDLE_NAMES = ["jira-service-management", "jira-service-desk"];
const SERVCO_COBRANDING_APPLICATION = "wac--service-collection-cobranding";
const JSM_COBRANDING_APPLICATION = "wac--service-collection-jsm-cobranding";

/**
 * Returns true when the user is in a JSM → Service Collection cross-flow.
 */
export const useIsJsmCrossflow = (): boolean => {
    const location = useLocation();

    return useMemo(() => {
        const params = new URLSearchParams(location.search);

        const application = params.get("application");
        if (application === SERVCO_COBRANDING_APPLICATION) {
            return false;
        }
        if (application === JSM_COBRANDING_APPLICATION) {
            return true;
        }

        if (
            params.get("primaryCollectionProduct") ===
            ProductKey.JIRA_SERVICE_MANAGEMENT
        ) {
            return true;
        }

        const bundle = params.get("bundle");
        if (bundle && JSM_BUNDLE_NAMES.includes(bundle)) {
            return true;
        }

        if (typeof document !== "undefined" && document.referrer) {
            try {
                const referrerUrl = new URL(document.referrer);
                const isTrustedHost =
                    referrerUrl.hostname === "atlassian.com" ||
                    referrerUrl.hostname.endsWith(".atlassian.com") ||
                    (typeof window !== "undefined" &&
                        referrerUrl.host === window.location.host);
                return (
                    isTrustedHost &&
                    JSM_REFERRER_PATTERN.test(referrerUrl.pathname)
                );
            } catch {
                return false;
            }
        }

        return false;
    }, [location.search]);
};
